import React, { Component, Fragment } from 'react'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { connect } from 'react-redux'
import StyleSheet from 'styles'
import Dependent from 'containers/shared/Dependent'
import { DealSheetActions } from 'actionsets'
import { ImageAvatar } from 'components'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { compose } from 'utils'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import Typography from '@material-ui/core/Typography'
import AutoSuggest from 'components/AutoSuggest'
import * as API from 'api'

export class FeaturedListingsForm extends Component {

  constructor(props) {
    super(props)
    DealSheetActions.bindActions(this)
  }

  dependsOn(){
    return this.actions.index({featured: true})
  }

  dependenciesMet(){
    return !this.props.requests.find(r => r.type === DealSheetActions.INDEX)
  }

  handleOnDrop = (to, from) => {
    let dealSheets = [...this.props.dealSheets]
    if(from < to) to -= 1
    dealSheets.splice(to, 0, dealSheets.splice(from, 1)[0])
    this.actions.setFeaturedListings({ids: dealSheets.map(({id}) => id)})
  }

  handleDeleteFeaturedListing = at => () => {
    let dealSheets = [...this.props.dealSheets]
    dealSheets.splice(at, 1)
    this.actions.setFeaturedListings({ids: dealSheets.map(({id}) => id)})
  }

  addFeaturedListing = ({target: { value: dealSheet }}) => {
    if(dealSheet && dealSheet.id && !this.props.dealSheets.find(({id}) => `${dealSheet.id}` === `${id}`)){
      let dealSheets = [...this.props.dealSheets, dealSheet]
      this.actions.setFeaturedListings({ids: dealSheets.map(({id}) => id), added: dealSheet})
    }
  }

  provideListings = query =>
    API.DealSheets
      .index({options: {
        page: {
          number: 1,
          size: 5
        },
        filter: {
          text: query,
          excluding: this.props.dealSheets.map(({id}) => id)
        }
      }})
      .then(({data}) => data)

  renderDealSheetItem = ({id, ticker, tagLine, emblemUrls}, position) =>
    <Fragment key={position}>
      <DraggableListItem position={position} id={id} onDrop={this.handleOnDrop}>
        <ImageAvatar alt='' urls={ emblemUrls }/>
        <ListItemText primary={ticker} secondary={tagLine}/>
        <ListItemSecondaryAction>
          <IconButton aria-label='Delete' onClick={this.handleDeleteFeaturedListing(position)}>
            <DeleteIcon/>
          </IconButton>
        </ListItemSecondaryAction>
      </DraggableListItem>
      <DraggableListItemDropZone position={position+1}>
      </DraggableListItemDropZone>
    </Fragment>

  render = () =>
    <Card className={styles.card}>
      <CardContent className={styles.content}>
        <Typography variant='h6'>
          Featured Listings
        </Typography>
        <Typography>
          Drag and drop to reorder
        </Typography>
        <AutoSuggest
          labelProvider={(({ticker, tagLine}) => `${ticker}-${tagLine}`)}
          label='Type here to add new featured listings'
          value=''
          fullWidth
          margin="normal"
          onChange={this.addFeaturedListing}
          onSuggestionsFetchRequested={(text, callback, error) => this.provideListings(text).then(callback).catch(error)}
        />
        <List>
          <DraggableListItemDropZone position={0}>
          </DraggableListItemDropZone>
          {this.props.dealSheets.map(this.renderDealSheetItem)}
        </List>
      </CardContent>
    </Card>
}

const styles = StyleSheet({
  draggableListItem: {
    cursor: 'pointer'
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  card: {
    flex: 1,
    minWidth: 300,
    alignSelf: 'flex-start',
    margin: 10,
    maxWidth: 1200
  },
})



export default compose(
  Dependent({loader: true, wrapperClassName: styles.wrapper, clearOnLoad: true}),
  connect(({dealSheets}) => {return dealSheets}),
  DragDropContext(HTML5Backend)
)(
  FeaturedListingsForm
)

/**
 * The collect function shared by our drag and drop sources
   The react-dnd equivalent to mapStateToProps
 */
function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget && connect.dropTarget(),
    connectDragSource: connect.dragSource && connect.dragSource(),
    isOver:            monitor.isOver     && monitor.isOver(),
    canDrop:           monitor.canDrop    && monitor.canDrop(),
    isDragging:        monitor.isDragging && monitor.isDragging()
  };
}


/**
 * Our Drag Source is a draggable list item.
 * The below object implements the target interface for the drag source
 */
const dragSource = {
  beginDrag(props, monitor){
    return props
  }
}
/**
 * A drag source connected component
 */
const DraggableListItem = DragSource('FeaturedListingItem', dragSource, collect)(
  class extends Component{
    render = () => {
      return this.props.connectDragSource(
        <div className={styles.draggableListItem}>
          <ListItem>
            {this.props.children}
          </ListItem>
        </div>
      )
    }
  }
)

/**
 * Our drag target is a draggable list item drop zone
 * The below object implements the target interface for the drop zone
 */
const dragTarget = {
  drop({position: to}, monitor) {
    const { position: from, onDrop} = monitor.getItem()
    onDrop(to, from)
  },
  canDrop(){
    return true
  }
}
/**
 * A drop target connected component
 */
const DraggableListItemDropZone = DropTarget('FeaturedListingItem', dragTarget, collect)(
  class extends Component{
    render = () => {
      return this.props.connectDropTarget(
        <div style={{
          width: '100%',
          height: '50px',
          marginBottom: '-25px',
          zIndex: '2',
          position: 'relative',
          marginTop: '-25px',
          ...(this.props.canDrop ? {} : {pointerEvents: 'none'}),
          ...(this.props.isOver ? {border: '2px dashed #cacaca'} : {})
        }}>
        </div>
      )
    }
  }
)

